import React from 'react';
import s from './InvoiceInfo.scss';
import get from 'lodash.get';
import { Text, Heading } from '@wix/design-system';
import { dateFormat, localDate } from '../../../core';
import { withTranslation } from '@wix/fe-essentials/i18n';
import { InvoiceStatus, } from '@wix/ambassador-wix-quotes-web/types';
import moment from 'moment';
import { WithInvoiceInfoLoader, } from '../../loaders/loaders-builder';
import { dateFormatter } from '@wix/crm-financial-formatters';
const diffInDaysFloored = ({ dateA, dateB }) => Math.floor(moment.duration(moment(dateA).diff(dateB)).as('days'));
export const ORDER_REFERENCE_CUSTOM_FIELD_KEY = 'invoices.document.order-number';
const InvoiceInfo = ({ t, invoice, isRecurring, status, documentCustomFields, customInvoiceNumberLabel, customFields, primarySiteLocale, }) => {
    const shortDateFormat = true;
    const date = primarySiteLocale
        ? dateFormatter(primarySiteLocale, shortDateFormat)
        : localDate(dateFormat({ locale: invoice.locale && invoice.locale.language }));
    const shouldModifyDatesForRecurringSpecialCase = isRecurring && status === InvoiceStatus.Draft;
    const referenceText = get(invoice.metaData, 'sourceProperties.referenceText');
    const dueDateOffset = shouldModifyDatesForRecurringSpecialCase
        ? diffInDaysFloored({
            dateA: get(invoice.dates, 'dueDate'),
            dateB: get(invoice.dates, 'issueDate'),
        })
        : null;
    const issueDate = shouldModifyDatesForRecurringSpecialCase
        ? moment().startOf('day').utc().toDate()
        : get(invoice.dates, 'issueDate');
    const dueDate = shouldModifyDatesForRecurringSpecialCase
        ? moment().add(dueDateOffset, 'days').startOf('day').utc().toDate()
        : get(invoice.dates, 'dueDate');
    const InfoLine = ({ children, ...props }) => (React.createElement(Text, { size: "tiny", weight: "thin", secondary: true, ...props }, children));
    const OrderReference = () => {
        const orderReferenceCustomField = customFields?.find(({ originCustomFieldKey }) => originCustomFieldKey === ORDER_REFERENCE_CUSTOM_FIELD_KEY);
        return orderReferenceCustomField ? (React.createElement(InfoLine, { dataHook: "order-reference" }, t('invoice-view:invoice-view.order-number.label', {
            orderNumber: orderReferenceCustomField.value.value,
        }))) : null;
    };
    const getCustomFields = () => (documentCustomFields ?? [])
        .filter(({ value, displayName }) => !!value && !!displayName)
        .map(({ displayName, value }, index) => (React.createElement("div", { key: index },
        React.createElement(InfoLine, { dataHook: `${displayName}-${index}-custom-field` }, t('invoice-view:price-quote.view.custom-field', {
            displayName,
            value,
        })))));
    const invoiceNumber = customInvoiceNumberLabel
        ? t('invoice-view:invoice_view.custom-invoice-number-label', {
            customInvoiceNumberLabel,
            number: invoice.number,
        })
        : t('invoice-view:invoice_view.invoice_number', { number: invoice.number });
    const dueDateLine = () => !!dueDate && (React.createElement(InfoLine, { className: s.date, dataHook: "due-date" }, `${t('invoice-view:quote.form.due_date')}: ${date(new Date(dueDate))}`));
    const issueDateLine = () => !!issueDate && (React.createElement(InfoLine, { className: s.date, dataHook: "issue-date" }, `${t('invoice-view:quote.form.issue_date')}: ${date(new Date(issueDate))}`));
    return (React.createElement("div", { className: s.info },
        React.createElement(Heading, { className: s.number, size: "large", dataHook: "invoice-number" }, invoiceNumber),
        React.createElement(OrderReference, null),
        !!referenceText && (React.createElement(InfoLine, { dataHook: "reference-text" }, referenceText)),
        issueDateLine(),
        dueDateLine(),
        documentCustomFields && documentCustomFields.length > 0 && (React.createElement("div", { "data-hook": "document-custom-fields", className: s.info }, getCustomFields()))));
};
export default WithInvoiceInfoLoader(withTranslation(['invoice-view', 'locale-data'])(InvoiceInfo));
//# sourceMappingURL=InvoiceInfo.js.map